import { reactive } from 'vue';

const Store = reactive({
  filter: [] as any,
  page: 0 as number,
});

export default Store;
